import { PropsWithChildren } from 'react'

import { Root } from '@radix-ui/react-radio-group'
import styled from 'styled-components'

import { Field } from 'core/hooks/useForm'

type RadioGroupProps<T extends string> = Field<T> &
  PropsWithChildren<{
    className?: string
    ariaLabel?: string
  }>

const RadioGroup = <T extends string>({
  className,
  ariaLabel,
  children,
  value,
  onChange,
  disabled,
  name,
}: RadioGroupProps<T>) => (
  <StyledRoot
    className={className}
    aria-label={ariaLabel}
    value={value}
    onValueChange={onChange}
    disabled={disabled}
    name={name}
  >
    {children}
  </StyledRoot>
)

export default RadioGroup

const StyledRoot = styled(Root)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
